//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const LN_DESC_MAP = {
    '开发商自行组织摇号': '该楼盘自行摇号，准确时间以项目公告为准',
    '开发商自行组织有序选房': '该楼盘不摇号，请您注意报名与开盘时间哦'
}
export default {
    props: {
        current_house: {
            type: Object
        },
        is_business: {
            type: Boolean,
            default: false
        },
    },
    components: {
    },
    computed: {
        ln_mode_desc () {
            return LN_DESC_MAP[this.current_house.ln_mode] || ''
        }
    }
}
